/* MatchingResultLabel.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _3 = "._19pkidpf{margin-top:0}";
const _2 = "._vwz41k8s{line-height:1.5rem}";
const _ = "._k48p1nn1{font-weight:400}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal, MatchingLabelSkeleton } from '@atlassian/mpac-primitives';
import { pluralize } from '@atlassian/mpac-utils';
import React from 'react';
import { TEST_IDS } from '../testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const H2 = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BodyNormal, _objectSpread(_objectSpread({
    as: "h2"
  }, props), {}, {
    children: children
  }));
};
const BodyStyled = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = H2,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48p1nn1 _vwz41k8s _19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BodyStyled.displayName = 'BodyStyled';
}
export const getCountLabel = count => count > 1000 ? 'over 1,000' : count;
const MatchingResultLabel = _ref3 => {
  let {
    isSearchQueryActive,
    totalCount,
    isLoading,
    areFiltersActive
  } = _ref3;
  if (isLoading) {
    return /*#__PURE__*/_jsx(BodyStyled, {
      "data-testId": TEST_IDS.MATCHING_LABEL_SKELETON,
      children: /*#__PURE__*/_jsx(MatchingLabelSkeleton, {})
    });
  }
  if (!isSearchQueryActive && !areFiltersActive) {
    return /*#__PURE__*/_jsxs(BodyStyled, {
      children: ["Showing ", getCountLabel(totalCount), " apps"]
    });
  }
  if (totalCount === 0 && !areFiltersActive) {
    return null;
  }
  return /*#__PURE__*/_jsxs(BodyStyled, {
    children: [totalCount === 0 ? 'No' : "Showing ".concat(getCountLabel(totalCount)), ' ', pluralize('match', totalCount, false, 'matches'), " for your query"]
  });
};
export default MatchingResultLabel;